<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Baja por archivo</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div></div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos"> Baja de Pacientes masivo</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="empresa">Empresa</label>
                <v-select
                    label="nombreComercial"
                    id="compania"
                    v-model="compania"
                    :options="lstCompania"
                    @input="seleccinarEmpresa($event)"
                    required
                >
                  <span slot="no-options">No hay datos...</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="plan">Planes</label>
                <v-select
                    label="nombrePlan"
                    id="plan_convenio"
                    v-model="planConvenio"
                    :options="lstPlanesConvenios"
                    required
                    :disabled="compania === null"
                >
                  <span slot="no-options">No hay datos...</span>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col size="6">
          <b-form-group align="left">
            <label for="archivo">Archivo</label>
            <b-form-file :disabled="planConvenio == null" v-model="archivo" placeholder="Seleccionar archivo" browse-text="Abrir" type="file"
                         @change="cargarArchivo($event)"></b-form-file>
            <b-form-text>
              El archivo de baja de pacientes debe tener los siguientes datos en el orden establecido( La columna correspondiente esta entre parentesis):

              <ul>
                <li>(A) ID paciente*</li>
              </ul>

              <p><small>Nota: los datos deben ser agregados apartir de la fila 2
                <br>
                El archivo no debe tener ningun tipo de margen.
              </small></p>


              <a href="/files/formato-bajas.xlsx" download> Descargar Formato</a>

            </b-form-text>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="ids.length  > 0">
        <b-col>
          Total de registos: {{ ids.length }}
        </b-col>
        <b-col>
          Econtrados en Plan: {{ enPlan}}
        </b-col>
        <b-col>
          No encontrados en Plan: {{ ids.length - enPlan}}
        </b-col>

      </b-row>
      <b-row v-if="loader">
        <b-col align="center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </b-col>
      </b-row>
      <b-row v-if="pacientes.length > 0">
        <b-col>
          <b-table
              id="Pacientes"
              thead-tr-class="columnas"
              :items="pacientes"
              :fields="fields"
              responsive="true"
              class="parrafos"
              fixed
          >
            <template v-slot:cell(fechaNacimiento)="row">
              {{ row.item.fechaNacimiento | formatoFecha }}
            </template>
            <template v-slot:cell(plan)="row">
              <b-badge v-if=" row.item.registroActivo" variant="primary">Si</b-badge>
              <b-badge v-else variant="danger">No</b-badge>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row v-if="pacientes.length > 0">
        <b-col>
          <b-button variant="primary" @click="darDeBaja" :disabled="loaderAcciones">
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span></b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import XLSX from "xlsx";

export default {
  name: "BajaPorArchivo",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      loaderAcciones: false,
      ids: [],
      pacientes: [],
      fields: [
        {key: "idPaciente", label: "ID", sortable: true},
        {key: "nombrePaciente", label: "Nombre(s)", sortable: true},
        {key: "fechaNacimiento", label: "Fecha de Nacimeinto", sortable: true},
        {key: "plan", label: "En Plan", sortable: true}
      ],
      compania: null,
      planConvenio: null,
      archivo: null,
      lstCompania: [],
      lstPlanesConvenios: [],
      enPlan: 0,
      fueraPlan: 0,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerListaEmpresas();
  },
  methods: {
    obtenerListaEmpresas() {
      this.$http
          .get(this.$api + "empresas/obtener")
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstCompania = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstCompania.push(item);
              });
            }
          })
          .catch(function (error) {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
    },
    seleccinarEmpresa(evento) {
      this.lstPlanesConvenios = [];
      this.planConvenio = null;
      this.plan_convenio = false;
      this.obtenerPlanesEmpresa(evento);
    },
    obtenerPlanesEmpresa(empresa) {
      // this.loaderPlanes = true;
      this.planConvenio = null;
      const parametros = {idEmpresa: empresa.idEmpresa}
      var url = "empresas/obtener/planes";

      this.$http
          .post(
              this.$api + url, parametros
          )
          .then((response) => {
            // this.loaderPlanes = false;
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstPlanesConvenios = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstPlanesConvenios.push(item);
              });
            }
          })
          .catch(function (error) {
            // this.loaderPlanes = false;
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => {
            this.plan_convenio = true;
          });
    },
    cargarArchivo(e) {
      this.pacientes = [];
      const files = e.target.files;
      const fileReader = new FileReader(); // construction function that can read the file content
      fileReader.onload = ev => {
        const data = ev.target.result;
        const workbook = XLSX.read(data, {
          type: "binary" // binary
        });
        const wsname = workbook.SheetNames[0]; //take the first sheet
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //Get the data in this table
        let lista = []

        lista = ws;

        lista.map(value => {
          this.ids.push(value["ID"]);
        })

        this.buscarPacientes();
      };
      fileReader.readAsBinaryString(files[0]);

    },
    buscarPacientes() {
      this.loader = true;
      this.$http.post(this.$api + "planConvenio/pacientes?idPlan="+ this.planConvenio.idPlan, this.ids).then((respuesta) => {
        if (respuesta.data.data) {
          this.pacientes = respuesta.data.data;

          this.enPlan = this.pacientes.filter(value => value.registroActivo).length
        }
      }).finally(() => {
        this.loader = false;
      });
    },
    darDeBaja() {
      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showConfirmButton: true,
        text: "Los datos a modificar solo serán los encontrados en el plan",
      }).then((aceptar) => {
        if (aceptar.value) {

          this.loaderAcciones = true;

          const datos = [];

          this.pacientes.map(value => {
            datos.push(value.idPaciente)
          })

          this.$http.post(this.$api + "planConvenio/bajaPacientes?idPlan="+ this.planConvenio.idPlan, datos).then(
              (respuesta) => {
                if (respuesta.data.data) {
                  this.$swal({
                    icon: "success",
                    text: "Pacientes actualizados correctamente",
                    confirmButtonText: "OK",
                  });
                  this.pacientes = [];
                  this.compania = null;
                  this.planConvenio = null;
                  this.archivo = null;

                } else {
                  this.$swal({
                    icon: "error",
                    title: "Ocurrio un error al procesar la solicitud",
                    showConfirmButton: false,
                    timer: 2500,
                  });
                }
              }).catch(reason => {
            console.error(reason)
            this.$swal({
              icon: "error",
              title: "Ocurrio un error al procesar la solicitud",
              showConfirmButton: false,
              timer: 2500,
            });
          }).finally(() => {
            this.loaderAcciones = false;
          });


        }
      });
    }
  }
}
</script>

<style scoped>

</style>